import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {QnaService} from 'src/app/modules/services/qna/qna.service';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-qna-card',
    templateUrl: './qna-card.component.html',
    styleUrls: ['./qna-card.component.css']
})
export class QnaCardComponent implements OnInit {
    @ViewChild('frContainer', {static: true}) frContainer: ElementRef;

    public id = null;
    public item: any;
    public current_lang = this.translate.getDefaultLang();

    constructor(private route: ActivatedRoute,
                private qnaService: QnaService,
                private translate: AppTranslateService,
                private translateS: TranslateService
    ) {
        translateS.onLangChange.subscribe(({lang}) => {
            this.current_lang = lang;

        });
    }

    ngOnInit(): void {

        this.route.queryParams.subscribe(params => {
            this.id = params.id;


        });
        this.loadcard();
    }


    loadcard() {
        {

            this.qnaService.loadcard(this.id)
                .subscribe(response => {

                    this.item = response['payload'];
                    this.frContainer.nativeElement.innerHTML = this.item.cont;




                });
        }

    }


}
